<template>
  <div class="modal-card">
    <header class="modal-card-head"> 
      <h4 class="modal-card-title" >
          {{ deliveryLabel }}
        <span class="line-height required-label has-text-dark is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal">
          * required
        </span>
      </h4>
    </header>
    <section class="modal-card-body is-size-2 is-marginless shipping-delivery-col">
      <div class="columns">
        <div class="column">
          <div class="field mb-5">
            <div class="field-label">
              <label class="label is-italic has-text-weight-semibold">Shipping Order</label>
            </div>
            <div class="field-body">
              <span class="has-text-weight-normal">{{ rowData.name }}</span>
            </div>
          </div>
            <div class="field">
            <div class="field-label">
              <label class="label is-italic has-text-weight-semibold">Destination Project</label>
            </div>
            <div class="field-body">
              <span class="has-text-weight-normal">{{ $_.get(rowData, 'delivery.deliveryProject.name', '') }}</span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns">
            <div class="column">
              <div class="field">
                <div class="field-label">
                  <label class="label is-italic has-text-weight-semibold">Earliest Ship By</label>
                </div>
                <div class="field-body has-text-weight-normal">
                  <field-date 
                    :item="rowData" 
                    :input-props="{
                      kind: 'delivery.deliveryStart', 
                      }" 
                    :is-edit="false"></field-date>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <div class="field-label">
                  <label class="label is-italic has-text-weight-semibold">Earliest Delivery By</label>
                </div>
                <div class="field-body has-text-weight-normal">
                  <field-date 
                    :item="rowData" 
                    :input-props="{
                      kind: 'delivery.deliverBy', 
                      }" 
                    :is-edit="false"></field-date>
                </div>
              </div>
            </div>
          </div>
            <div class="columns">
              <div class="column pt-0">
                <div class="field">
                  <div class="field-label">
                    <label class="label is-italic has-text-weight-semibold">Delivery Location</label>
                  </div>
                  <div class="field-body  has-text-weight-normal is-size-3">
                    <span>{{ $_.get(rowData, 'delivery.deliveryLocation.name', '') }}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="is-divider my-0"></div>
      <div class="table-container mt-2" v-if="isGetDeliveryQRCode || isGetDeliveryShippinglists">
        <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis mb-2">Select Deliveries*</h3>
        <mf-table
            ref="shipTable"
            :apiMode="false"
            :checkedRows="checkedRow"
            :tableProps="tableCols.getQrDeliveries"
            :loadData="loadData"
            tableName="ShippingReceive"
            @checkbox-toggled="selectedRow"
            class="mt-0"
        >
        </mf-table>
      </div>
    </section>
    <footer>
      <div class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-outlined" @click="cancel()">Cancel</button>
        <button v-if="isGetDeliveryQRCode"
          class="button has-background-black-bis"
          :disabled="!selectedQrDeliveries.length"
          @click="getDeliveryQRCodes"
        >Get QR Code</button>
        <button v-else-if="isGetDeliveryShippinglists"
          class="button has-background-black-bis"
          :disabled ="!getDeliveryShippinglistsArray.length"
          @click="getDeliveryShippinglists"
        >Get Shipping Labels</button> 
      </div>
    </footer>
  </div>
  <o-loading :active="isLoading" :full-page="false" :can-cancel="true"/>
</template>

<script>
  import {
    reactive, toRefs, ref, defineAsyncComponent, onMounted,
    computed,
  } from 'vue';
  import tableDefinition from '@/components/table-cols/shippingRecieveConfig';
  import _ from 'lodash';
  import { useToast } from 'vue-toastification';
  import { useStore } from 'vuex';
  import Shipping from '@/models/Shipping';
  import BaseCardColumn from '@/components/card-edit/BaseCardColumn.vue';
  import SearchBar from '@/components/SearchBar.vue';
  import Projects from '@/models/Projects';
  import MfDate from '@/components/abstract/MfDate.vue';
  import OrderNotify from '@/components/OrderNotify.vue';
  import Print from '@/components/utils/Print';
  const MfTable = defineAsyncComponent(() => import('@/components/table-fields/MfTable.vue'));

  export default {
  name: 'GetDeliveryQRandShippingPDF',
  props: {
    rowData: {
      type: Object,
      default: () => {
      },
    },
    isGetDeliveryQRCode : {
      type: Boolean,
      default: false,
    },
    isGetDeliveryShippinglists : {
      type: Boolean,
      default: false,
    }
   
  },
  components: {
    MfTable,
    'base-column': BaseCardColumn,
    'search-bar': SearchBar,
    MfDate,
    'order-notify': OrderNotify,
  },
  setup(props, { emit }) {
    const toast = useToast();
    const store = useStore();
    const shipTable = ref(null);
    const data = reactive({
      tableCols: tableDefinition,
      isLoading: false,
      updateTable: 0,
      selectedDeliveries: [],
      selectedQrDeliveries: [],
      getDeliveryShippinglistsArray : [],
      projectUsers: {},
      deliveryLabel: ''
    });
    const projectId = props.rowData.delivery.currentProject._id;
    const cancel = () => {
      emit('close');
      emit('refresh-card');
    };
    
    const deliveryLabel = computed(() => {
      if (props.isGetDeliveryShippinglists) return 'Bulk Get Delivery Shipping Lists';
      if (props.isGetDeliveryQRCode) return 'Bulk Get Delivery QR Code Labels';
    });
    const loadData = (() => {
      if (props.isGetDeliveryQRCode) {
        return props.rowData.partialShipments.filter((partial) => partial.status !== "unscheduled") || [];
      } else if (props.isGetDeliveryShippinglists) {
        return props.rowData.partialShipments.filter((partial) => partial.status !== "unscheduled") || [];
      }
    });
    
    const getDeliveryQRCodes = async () => {
      data.isLoading = true;
      data.progressCount = 0; 
      try {
        const user = store.state.userData;
        for await (const delivery of data.selectedQrDeliveries) {
          if (delivery && delivery._id) {
            const reqObj = {
              shippingId: delivery._id,
              projectId: delivery.project?._id || props.rowData.delivery?.deliveryProject?._id,
              tzinfo: new Date().getTimezoneOffset(),
              printSerial: false,
              type: 'shipping',
            };
            const qrLabel = await Shipping.getShippingLabel(reqObj);
            if (qrLabel && qrLabel.length) {
              await Print.printQrLabel(qrLabel, user);
            } else {
              toast.warning(`No QR Code generated for ${delivery.name}`);
            }
            
            data.progressCount += 1;
          }
        }
        toast.success('All QR Code Labels generated successfully');
      } catch (e) {
        console.error('Error fetching QR labels:', e);
        toast.error(e.message || 'Error while generating QR Code Labels');
      } finally {
        data.isProgressBar = false;
        cancel();
      }
    };
    const getDeliveryShippinglists = async () => {
      data.isLoading = true;
      // data.progressCount = 0; 
      try {
        const user = store.state.userData;
        for await (const delivery of data.getDeliveryShippinglistsArray) {
          if (delivery && delivery._id) {
            const reqObj = {
              shippingId: delivery._id,
              projectId: delivery.project?._id || props.rowData.delivery?.deliveryProject?._id,
              tzinfo: new Date().getTimezoneOffset(),
              printSerial: false,
              type: 'shipping',
            };
            const qrLabel = await Shipping.getShippingLabel(reqObj);
            if (qrLabel && qrLabel.length) {
              const pdfParams = {
                shippingId: delivery._id,
                projectId: delivery.project?._id || props.rowData.delivery?.deliveryProject?._id,
                tzinfo: new Date().getTimezoneOffset(),
                qrLabel: qrLabel[0].imageData,
                compLogo: qrLabel[0].compLogo,
                userInfo: user.fullName,
                company: {
                  _id: user.company,
                  name: user.companyName,
                },
              };
              const res = await Shipping.generateShippingPdf(pdfParams);
              if (!res?.data) {
                toast.warning(`No Shipping List generated for ${delivery.name}`);
              } else {
                const link = document.createElement('a');
                link.href = res.data;
                link.download = `${delivery.name}-ShippingList.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            } else {
              toast.warning(`No label found for ${delivery.name}`);
            }
            // data.progressCount += 1;
          }
        }
        toast.success('All Shipping Lists generated successfully');
      } catch (e) {
        console.error('Error fetching Shipping Lists:', e);
        toast.error(e.message || 'Error while generating Shipping Lists');
      } finally {
        data.isLoading = false;
        cancel();
      }
    };

    const selectedRow = (rows) => {
      data.selectedQrDeliveries = rows;
      data.getDeliveryShippinglistsArray = rows
    }
    const fetchUsers = async (pId) => {
      const allUsers = await Projects.linkedProjectUsers([pId]);
      const users = _.filter(allUsers, (usr) => usr.company === _.get(store.state.userData, 'company._id', store.state.userData.company));
    return users;
    };
    onMounted (async ()=> {     
      data.projectUsers[projectId] = [];
      if (_.isEmpty(data.projectUsers[projectId])) {      
        const users = await fetchUsers(projectId);        
        if (users.length) data.projectUsers[projectId] = users;
      }
    })
    return {
      ...toRefs(data),
      cancel,
      loadData,
      selectedRow,
      getDeliveryQRCodes,
      deliveryLabel,
      getDeliveryShippinglists
    };
  },

};
</script>
<style scoped>
.modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
     background-color: #fff !important;
  }
</style>